const DiffStyles = () => {
  return (
    <style jsx global>{`
      .old-version-highlight {
        background-color: #fee2e2;
        color: #991b1b;
        border-radius: 2px;
        padding: 1px 2px;
        font-weight: 500;
        border-bottom: 2px solid #ef4444;
      }

      :global(.dark) .old-version-highlight {
        background-color: rgba(127, 29, 29, 0.4);
        color: #fca5a5;
        border-bottom: 2px solid #dc2626;
      }

      .new-version-highlight {
        background-color: #dcfce7;
        color: #166534;
        border-radius: 2px;
        padding: 1px 2px;
        font-weight: 500;
        border-bottom: 2px solid #22c55e;
      }

      :global(.dark) .new-version-highlight {
        background-color: rgba(22, 101, 52, 0.4);
        color: #86efac;
        border-bottom: 2px solid #16a34a;
      }

      .added-text {
        background-color: #dcfce7;
        color: #166534;
        border-radius: 2px;
        padding: 1px 2px;
        font-weight: 500;
        border-bottom: 2px solid #22c55e;
      }

      :global(.dark) .added-text {
        background-color: rgba(22, 101, 52, 0.4);
        color: #86efac;
        border-bottom: 2px solid #16a34a;
      }

      .removed-text {
        background-color: #fee2e2;
        color: #991b1b;
        border-radius: 2px;
        padding: 1px 2px;
        font-weight: 500;
        border-bottom: 2px solid #ef4444;
      }

      :global(.dark) .removed-text {
        background-color: rgba(127, 29, 29, 0.4);
        color: #fca5a5;
        border-bottom: 2px solid #dc2626;
      }

      .paragraph-added {
        background-color: #dcfce7;
        padding: 4px;
        border-radius: 3px;
        border-left: 3px solid #22c55e;
      }

      :global(.dark) .paragraph-added {
        background-color: rgba(22, 101, 52, 0.3);
        border-left: 3px solid #16a34a;
      }

      .paragraph-removed {
        background-color: #fee2e2;
        padding: 4px;
        border-radius: 3px;
        border-left: 3px solid #ef4444;
      }

      :global(.dark) .paragraph-removed {
        background-color: rgba(127, 29, 29, 0.3);
        border-left: 3px solid #dc2626;
      }

      .split-view-content {
        overflow-y: auto;
        max-height: 60vh;
        line-height: 1.6;
      }

      .diff-unified {
        line-height: 1.6;
      }

      .diff-container-wrapper {
        max-height: 60vh;
        overflow-y: auto;
      }

      .diff-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        font-family:
          ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
          'Liberation Mono', 'Courier New', monospace;
        font-size: 0.875rem;
        line-height: 1.5;
      }

      .diff-table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
      }

      .diff-line-num {
        width: 40px;
        padding: 0 8px;
        text-align: right;
        color: #6b7280;
        background-color: #f9fafb;
        user-select: none;
        border-right: 1px solid #e5e7eb;
      }

      :global(.dark) .diff-line-num {
        color: #9ca3af;
        background-color: #1f2937;
        border-right: 1px solid #374151;
      }

      .diff-line-num.empty {
        background-color: #f3f4f6;
      }

      :global(.dark) .diff-line-num.empty {
        background-color: #111827;
      }

      .diff-line {
        padding: 2px 8px;
        white-space: pre-wrap;
        word-break: break-word;
      }

      .diff-line.removed {
        background-color: #fee2e2;
      }

      :global(.dark) .diff-line.removed {
        background-color: rgba(127, 29, 29, 0.3);
      }

      .diff-line.added {
        background-color: #dcfce7;
      }

      :global(.dark) .diff-line.added {
        background-color: rgba(22, 101, 52, 0.3);
      }

      .diff-line.unchanged {
        background-color: #ffffff;
      }

      :global(.dark) .diff-line.unchanged {
        background-color: #111827;
      }

      .diff-marker {
        display: inline-block;
        width: 12px;
        color: #64748b;
        font-weight: bold;
      }

      :global(.dark) .diff-marker {
        color: #94a3b8;
      }

      button[data-active='true'] {
        background-color: #f3f4f6;
        font-weight: 500;
      }

      :global(.dark) button[data-active='true'] {
        background-color: #374151;
      }

      @media (max-width: 640px) {
        .diff-container {
          font-size: 0.75rem;
        }

        .diff-line-num {
          width: 30px;
          padding: 0 4px;
        }

        .diff-line {
          padding: 2px 4px;
        }
      }
    `}</style>
  );
};

export default DiffStyles;
